module.exports = __webpack_public_path__ + "img/boiler-W-light.d9f49b44.png";